<template>
  <div>
    <template v-if="isRegularFieldType">
      <q-input
        v-model="model"
        outlined
        bg-color="white"
        dense
        :label="field.label"
        tabindex="0"
        :type="type"
        @update:modelValue="$emit('input', model)"
        @keyup.enter="$emit('on-enter', model)"
      ></q-input>
    </template>
  </div>
</template>

<script>
export default {
  name: "system-form-field",

  data() {
    return {
      model: null,
    };
  },

  props: {
    field: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {},
  },

  computed: {
    isRegularFieldType() {
      return (
        this.type === "text" ||
        this.type === "numeric" ||
        this.type === "number"
      );
    },

    type() {
      if (this.field.type === "numeric") return "number";

      return this.field.type ?? "text";
    },
  },

  created() {
    this.model = this.value;
  },
};
</script>

<style>
</style>